import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ModalDismissReasons, NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TecRMIBusinessService } from '../../../../business-services/Tec-RMI.service';
import { GearBoxModel, FilterDataModel, CooGroupModel, MaintenanceWorkModel, WorkViewModel, PartViewModel, AvailableStockBalanceModel, StockBalanceModel } from 'projects/Administration/src/app/business-entities/tecrmi-model';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { VehicleBusinessService } from '../../../../business-services/vehicle-service';
import { EditAppointmentService } from 'projects/Administration/src/app/business-services/edit-appointment.service';
import { AppointmentList } from 'projects/Administration/src/app/business-entities/appointmentList-model';
import { VehicleListViewModel } from 'projects/Administration/src/app/business-entities/vehicle-list-view-model';
import { AppointmentWorkOrderComponent } from '../appointment-work-order/appointment-work-order.component';
import { isNullOrUndefined } from '@swimlane/ngx-datatable';
import { TranslateService } from '@ngx-translate/core';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import * as Enums from 'projects/Autofacets-Core/src/app/utils/enums';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-tec-rmi-popup',
  templateUrl: './tec-rmi-popup.component.html',
  styleUrls: ['./tec-rmi-popup.component.css']
})
export class TecRmiPopupComponent implements OnInit {
  // @Input()  contactDetails: AppointmentDetail;
  @ViewChild(AppointmentWorkOrderComponent) child: AppointmentWorkOrderComponent;
  openPanels: Array<string> = ['first-panel', 'second-panel', 'third-panel'];
  gearBoxList: GearBoxModel[];
  cooGroupList: CooGroupModel[];
  vehicleWorkModel: MaintenanceWorkModel;
  serviceProposal: any;
  tecDocType: any;
  mileage: number;
  regDate: Date;
  setSelectedService:boolean = false;
  selectedGearBoxId: number;
  selectedService: number;
  updatedSelectedService:number;
  selectedProposal?: boolean;
  defaultWorkId: number[];
  appointmentDetails: AppointmentList;
  currentVehicleDetails: VehicleListViewModel;
  reFillCooGroups: boolean;
  reFillServiceProposals: boolean;
  cartMainServices: WorkViewModel[];
  cartAdditionalServices: WorkViewModel[];
  cartPartItems: PartViewModel[];
  cartServiceIds: any[];
  clearExtraServies: boolean = false;
  availableStockBalance: AvailableStockBalanceModel[];
  articleStockData: AvailableStockBalanceModel[] = [];
  displayStockDetails:StockBalanceModel[]=[];
  selectedtab: number = 1
  isErrorOnStockBalanceStep : boolean = false
  licensePlateClass: string;
  workSteps : WorkViewModel;
  LastKilometer: number;
  NextKilometer: number;
  LastDate : any;
  NextDate : any;


  tabs: any = [
    { id: 1, name: 'lblStep1' , disable : false},
    { id: 2, name: 'lblStep2' , disable : false},
    { id: 3, name: 'lblStep3' , disable : false},
    { id: 4, name: 'lblServiceSelection' , disable : false},
    { id: 5, name: 'lblCheckOut' , disable : false},
    { id: 6, name: 'lblStockBalance' , disable : false},
  ]

  @Input() filterModel: FilterDataModel = {
    typeId: null,
    kindOfGearBox: null,
    currentMileage: 0,
    initalRegistrationDate: '',
    cooGroupId: null,
    regDate: ''
  };

  constructor(
    private activeModal: NgbActiveModal,
    private tecRMIService: TecRMIBusinessService,
    private vehicleService: VehicleBusinessService,
    private spinner: NgxSpinnerService,
    private datepipe: DatePipe,
    public editAppointmentService: EditAppointmentService,
    public translate: TranslateService,
    private modalService: NgbModal,
    private globalSetting: GlobalSetting,
    private toastr: ToastrService,
  ) { }

  ngOnInit(): void {
    this.initialize();

  }

  initialize() {
    this.appointmentDetails = this.editAppointmentService.appointmentDetails;
    this.licensePlateClass = this.globalSetting.getGlobalLicencePlate();
    this.getVehicleDetail();
    // this.tecDocType = 153759// 60203; //153759; //todo : this should be retrived from vehicle detail
    this.selectedProposal = true;
    this.cartMainServices = [];
    this.cartAdditionalServices = [];
    this.cartServiceIds = [];
    this.cartPartItems = [];
  }

  getVehicleDetail() {
    this.spinner.show();
    let licensePlate = this.appointmentDetails.licensePlate;
    this.vehicleService.getVehicleByLicencePlateNo(licensePlate).then((result) => {
      if (result) {
        this.currentVehicleDetails = result.responseObject;
        if (this.currentVehicleDetails) {
          this.filterModel.currentMileage = this.currentVehicleDetails.mileage;
          this.filterModel.regDate = this.currentVehicleDetails.registrationDate;
          if (this.currentVehicleDetails.tecDocType != null) {
            this.tecDocType = parseInt(this.currentVehicleDetails.tecDocType)
            this.tecRMIService.checkVehicleHasServiceProposal(this.tecDocType).then((resp)=>{
              if (resp && resp.responseObject===false) {
                let msg = this.translate.instant("lblVehicleHasNoServiceProposal");
                this.toastr.warning(msg);
                this.selectedtab=3;
                //first 3 step disable
                this.tabs[0].disable=true;
                this.tabs[1].disable=true;
                this.tabs[2].disable=true;
                this.showNextTab();
              }
              else
              {
                this.getGearBoxList();
              }
            },
            _error => {
            this.spinner.hide();
          });
          }
          else {
            this.updateTecDocIds();
          }
        }
      }
      this.spinner.hide();
    },
      _error => {
        this.spinner.hide();
      });
  }

  updateTecDocIds() {
    this.spinner.show();
    let licensePlate = this.appointmentDetails.licensePlate;
    this.tecRMIService.updateTecDocIds(licensePlate).then(result => {
      if (result != null) {
        let tecDocType = result
        this.tecDocType = parseInt(tecDocType)
      }
      else {
        this.tecDocType = 153759// 60203; //153759; //todo : this should be retrived from vehicle detail
      }
      this.getGearBoxList();

      this.spinner.hide();
    },
      _error => {
        this.spinner.hide();
      });
  }
  changeMileage(_event: any): void {
    this.reFillCooGroups = true;
    this.reFillServiceProposals = true;
  }

  changeDate(_event: any): void {
    this.reFillCooGroups = true;
  }

  onGearBoxChanged(_event: any): void {
    this.reFillCooGroups = true;
  }

  getGearBoxList() {
    this.spinner.show();
    this.tecRMIService.getGearBoxList(this.tecDocType).then(result => {
      if (result) {
        this.gearBoxList = result.responseObject;
        if(this.gearBoxList===null || this.gearBoxList.length===0)
          {
            let msg = this.translate.instant("lblGearboxInformationNotAvailable");
            this.toastr.error(msg);
          }       
        let transmission = this.currentVehicleDetails.transmission.toLowerCase()
        let gearBoxValue = this.gearBoxList.find(gearBox => gearBox.value.toLowerCase().substring(0, 3) === transmission);

        if (gearBoxValue != null) {
          switch (gearBoxValue.key) {
            case 65:
              this.filterModel.kindOfGearBox = Enums.TransmissionType.AutomaticGearBox;
              break;
            case 77:
              this.filterModel.kindOfGearBox = Enums.TransmissionType.ManualGearBox;
              break;
            case 81:
              this.filterModel.kindOfGearBox = Enums.TransmissionType.AutomatedGearBox;
              break;
            default:
              break;
          }
        }
      }
      this.spinner.hide();
    },
      _error => {
        this.spinner.hide();
      });
  }

  getCooGroupList() {
    if (!this.cooGroupList || this.reFillCooGroups) {
      this.spinner.show();
      this.filterModel.initalRegistrationDate = (this.filterModel.regDate != '') ? this.datepipe.transform(Utility.getDateStringToDate(this.filterModel.regDate), 'yyyy-MM-dd') : '';
      this.filterModel.typeId = this.tecDocType;
      this.tecRMIService.getCooGroupList(this.filterModel).then(result => {
        if (result) {
          this.cooGroupList = result.responseObject;
          this.reFillServiceProposals = true;
          this.reFillCooGroups = false;
        }
        this.spinner.hide();
      },
        _error => {
          this.spinner.hide();
        });
    }
  }

  getVehicleServiceList() {
    if (!this.vehicleWorkModel) {
      this.spinner.show();
      this.tecRMIService.getVehicleMaintenanceWorkList(this.tecDocType).then(result => {
        if (result) {
          this.vehicleWorkModel = result.responseObject;
          this.getDefaultWorkList();
        }
        this.spinner.hide();
      },
        _error => {
          this.spinner.hide();
        });
    }
    else {
      if (this.selectedProposal != undefined) {
        this.getDefaultWorkList();
      }
    }
  }

  getServiceProposal() {
    if (!this.serviceProposal || this.reFillServiceProposals) {
      this.spinner.show();
      this.tecRMIService.getVehicleServiceProposal(this.filterModel).then(result => {
        if (result) {
          this.serviceProposal = result.responseObject;
          this.reFillServiceProposals = false;
          this.LastKilometer = this.serviceProposal.lastKm? this.serviceProposal.lastKm :null;
          this.NextKilometer = this.serviceProposal.nextKm? this.serviceProposal.nextKm :null;

          let lastMonth = Utility.getDateStringToDate(this.filterModel.regDate);
          let nextMonth = Utility.getDateStringToDate(this.filterModel.regDate);

          lastMonth.setMonth(lastMonth.getMonth() + (this.serviceProposal.lastMonth ? this.serviceProposal.lastMonth : 0));
          this.LastDate=lastMonth.toISOString();

          nextMonth.setMonth(lastMonth.getMonth() + (this.serviceProposal.nextMonth ? this.serviceProposal.nextMonth : 0) );
          this.NextDate=nextMonth.toISOString();
        }
        this.spinner.hide();
      },
        _error => {
          this.spinner.hide();
        });
    }
  }

  getDefaultWorkList() {
    this.defaultWorkId = [];
    if (this.selectedProposal) {
      this.serviceProposal?.previousServiceInfo?.forEach(element => {
        this.defaultWorkId.push(element.workId);
      });
    }
    else if (!this.selectedProposal) {
      this.serviceProposal.nextServiceInfo.forEach(element => {
        this.defaultWorkId.push(element.workId);
      });
    }
    if (this.vehicleWorkModel) {
      if (this.clearExtraServies) {
        this.cartServiceIds = [];
      }
      if (this.vehicleWorkModel.additionalWorks && this.clearExtraServies) {
        //by default mark all additional work items to false
        this.vehicleWorkModel.additionalWorks.forEach(s => {
          s.workSteps.forEach(elements => {
            elements.isChecked = false;
          });
        });
      }
      if (this.vehicleWorkModel.services) {
        //set selected service as per default service
        this.vehicleWorkModel.services.forEach(s => {
          s.workSteps.forEach(element => {
            if (this.defaultWorkId.indexOf(element.workId) > -1) {
              if(this.setSelectedService){
                this.selectedService = this.updatedSelectedService ? this.updatedSelectedService : element.workId;
                this.workSteps = element
              }
              else{
                this.selectedService = element.workId;
                this.workSteps = element
              }
              this.cartServiceIds.push(element.workId.toString());
            }
          });
        });
        if((this.selectedService != null || this.selectedService != undefined) && (this.workSteps != null || this.workSteps != undefined))
        {
          this.getSelectedServiceParts(this.workSteps,this.selectedService)
        }
      }
      if (this.vehicleWorkModel.additionalWorks) {
        //set additional service as per default service
        this.vehicleWorkModel.additionalWorks.forEach(s => {
          s.workSteps.forEach(element => {
            if (this.defaultWorkId.indexOf(element.workId) > -1) {
              element.isChecked = true;
              this.cartServiceIds.push(element.workId.toString());
            }
          });
        });
      }
      this.clearExtraServies = false;
    }
  }

  getSelectedServiceParts(element: WorkViewModel, selectedServiceNum: number) {
    if(selectedServiceNum == element.workId)
    {
      this.getParts(element)
    }
  }

  onProposalChange(_event) {
    this.clearExtraServies = true;
    if (this.vehicleWorkModel) {
      this.getDefaultWorkList();
    }
  }

  ManageCartServices(event) {
    let workId = event.target.value;
    if (event.target.checked) {
      this.cartServiceIds.push(workId);
    }
    else {
      let index = this.cartServiceIds.indexOf(workId);

      if (index !== -1) {
        this.cartServiceIds.splice(index, 1);
        //remove the selected parts of this unselected cart service
        this.vehicleWorkModel.additionalWorks.forEach(s => {
          s.workSteps.forEach(element => {
            if (element.workId == workId) {
              element.parts.forEach(item => { item.isChecked = false; })
            }
          });
        });
      }
    }
  }

  getCartDetails() {
    if (this.vehicleWorkModel && this.selectedService) {
      this.cartMainServices = [];
      this.vehicleWorkModel.services.forEach(s => {
        s.workSteps.forEach(element => {
          if (this.selectedService == element.workId) {
            this.cartMainServices.push(element);
          }
        });
      });
    }

    this.cartAdditionalServices = [];
    if (this.cartServiceIds && this.cartServiceIds.length > 0) {
      this.cartAdditionalServices = [];
      this.vehicleWorkModel.additionalWorks.forEach(s => {
        s.workSteps.forEach(element => {
          if (this.cartServiceIds.indexOf(element.workId.toString()) > -1) {
            this.cartAdditionalServices.push(element);
          }
        });
      });
    }
  }

  addPartToCart(part: PartViewModel) {
    if(part.isChecked)
    {
      this.cartPartItems.push(part);
    }    
  }

  removePartFromCart(part: PartViewModel) {
    let index = this.cartPartItems.indexOf(part);
    if (index !== -1) {
      this.cartPartItems.splice(index, 1);
    }
    part.isChecked = false;
  }

  setPartListForWork(item: any) {
    //set parts to worksteps...so no need to reload the parts in component
    let flag = false;
    if (item) {
      this.vehicleWorkModel.services.forEach(s => {
        if (!flag) {
          s.workSteps.forEach(element => {
            if (item.workId == element.workId) {
              element.parts = item.parts;
              flag = true;
            }
          });
        }
      });

      if (!flag) {
        this.vehicleWorkModel.additionalWorks.forEach(s => {
          if (!flag) {
            s.workSteps.forEach(element => {
              if (item.workId == element.workId) {
                element.parts = item.parts;
                flag = true;
              }
            });
          }
        });
      }
    }
  }

  mainServiceChanged(work:WorkViewModel) {
    this.updatedSelectedService = work.workId;
    this.vehicleWorkModel.services.forEach(s => {
      s.workSteps.forEach(element => {
        if (this.selectedService != element.workId) {
          element.parts?.forEach(item => { item.isChecked = false; })
        }
      });
    });
  }

  removeExtraService(item) {
    let index = this.cartAdditionalServices.indexOf(item);
    if (index !== -1) {
      this.cartAdditionalServices.splice(index, 1);
      //on removing item from cart - mark it and its part unchecked from the service list
      //remove the selected parts of this unselected cart service
      this.vehicleWorkModel.additionalWorks.forEach(s => {
        s.workSteps.forEach(element => {
          if (element.workId == item.workId) {
            element.isChecked = false;
            if (element.parts) {
              element.parts.forEach(item => this.removePartFromCart(item))
            }
          }
        });
      });

      index = this.cartServiceIds.indexOf(item.workId.toString());
      if (index !== -1) {
        this.cartServiceIds.splice(index, 1);
      }
    }
  }

  removeMainService(item) {
    let index = this.cartMainServices.indexOf(item);
    if (index !== -1) {
      this.cartMainServices.splice(index, 1);
      this.selectedService = null;
      //on removing item from cart - mark it and its part unchecked from the service list
      //remove the selected parts of this unselected cart service
      this.vehicleWorkModel.services.forEach(s => {
        s.workSteps.forEach(element => {
          if (item.workId == element.workId) {
            if (element.parts) {
              element.parts.forEach(item => this.removePartFromCart(item))
            }
          }
        });
      });
    }
  }

  getParts(element: WorkViewModel) {
    element.showParts = true;
    this.setSelectedService = true;
  }

  showPreviousTab() {
    if (this.selectedtab == 2 && this.tabs[0].disable===false) {
      //step 1
      this.selectedtab = 1;
    }
    else if (this.selectedtab == 3 && this.tabs[1].disable===false) {
      //step 2
      this.selectedtab = 2;
      this.getCooGroupList();
    }
    else if (this.selectedtab == 4 && this.tabs[2].disable===false) {
      //step 3
      this.selectedtab = 3;
      this.getServiceProposal();
    }
    else if (this.selectedtab == 5 && this.tabs[3].disable===false) {
      // step 4
      this.selectedtab = 4;
      this.getVehicleServiceList();
    }
    else if (this.selectedtab == 6 && this.tabs[4].disable===false) {
      // step 5
      this.selectedtab = 5;
    }
  }

  showNextTab() {
    if (this.selectedtab == 1) {
      //step 2
      this.selectedtab = 2;
      this.getCooGroupList();
    }
    else if (this.selectedtab == 2) {
      //step 3
      this.selectedtab = 3;
      this.getServiceProposal();
    }
    else if (this.selectedtab == 3) {
      //step 4
      this.selectedtab = 4;
      this.getVehicleServiceList();
    }
    else if (this.selectedtab == 4) {
      //step 5
      this.selectedtab = 5;
      this.getCartDetails();
    }
    else if (this.selectedtab == 5) {
      //step 6
      this.selectedtab = 6;
      this.isErrorOnStockBalanceStep = false
      this.GetAvailableStock();
    }
    else if (this.selectedtab == 6) {
      //check out
      this.selectedtab = 6;
      this.SaveData();
    }

  }

  GetAvailableStock() {
    this.spinner.show();

    // let yFilter = [];
    // this.cartPartItems.forEach(x => {
    //   let xFilter = x.genArtNoList.map(x => {
    //     yFilter.push(x)
    //   })
    // })    
    
    //updated logic to add distinct genARTNumberonly to yfilter
    let yFilter = [];
    this.cartPartItems.forEach(x => {
      let xFilter = x.genArtNoList.map(x => {
        if(yFilter && yFilter.length>0)
        {
          let genARTAlreadyExists=yFilter.some(z=> z == x);
          if(!genARTAlreadyExists)
          {
            yFilter.push(x);
          }
        }
        else
        {
          yFilter.push(x);
        }
      })
    })

    let viewModel = {
      BranchId: this.appointmentDetails.dealerId,
      GenArtNumberList: yFilter,
      LicensePlate: this.appointmentDetails.licensePlate,
      AppointmentId : this.appointmentDetails.appointmentId
    }
    this.displayStockDetails=[];
    //Retriving stock from genARTNumber Only , not from the part number
    this.tecRMIService.getAvailableStock(viewModel).then(result => {
      if (result != null) {
        this.availableStockBalance = result.responseObject

        //this below logic : stock with same genARTNumber, will always assign the same PartNumber, even though we have selected multiple part number from service selection wich have same genARTNumber
        //No mapping logic that shows, stock belong to that particular genARTNumber+partNumber (as stock retrive from genARTNumber only)
        //so below logic may not assign the correct partnumber to article/stock list

        this.availableStockBalance.forEach(element => {
          let genArtNo = element.genArtNumber

          this.cartPartItems.forEach(x => {
            x.genArtNoList.forEach(y => {
              if (y == genArtNo) {
                element.qty = x.qty;
                element.partCode = x.partNo
              }
            })
          })

        })
        this.availableStockBalance = this.availableStockBalance.sort((a, b) => a.name.localeCompare(b.name));
        this.availableStockBalance.forEach(item => {
            let group = this.displayStockDetails.find(g => g.name === item.name);        
            if (group) {
                group.stockDetails.push(item);
            } else {
                this.displayStockDetails.push({
                    name: item.name,
                    stockDetails: [item]
                });
            }
        });
      }
      this.spinner.hide();
    },
      _error => {
        this.spinner.hide();
      });
  }
  removeArticleFromCart(article: AvailableStockBalanceModel) {
    let index = this.articleStockData.indexOf(article);
    if (index !== -1) {
      this.articleStockData.splice(index, 1);
    }
    article.isChecked = false;
  }

  addRemoveArticleToCart(event: any, article: any) {
    if (event.target.checked == true) {
      article.IsChecked = true
    }
    else {
      article.IsChecked = false;
    }

  }
  SaveData() {
    let modelHeadermsg = this.translate.instant("lblAdd");
    let modelBodymsg = this.translate.instant("lblSureToAddLabor");
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
      // This is intentional
    }, (reason) => {
      if (this.getDismissReason(reason)) {
        this.SaveServiceData()
      }

    });
  }
  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }

  SaveServiceData() {  
    this.spinner.show();

    //Insert selected articles in articleStockData array
    // this.availableStockBalance.forEach(article=> {
    //   if(article.isChecked){
    //     this.articleStockData.push(article)
    //   }
    // })
    
    this.displayStockDetails.forEach(item=>
      {
        item.stockDetails.forEach(article=>{
          if(article.isChecked){
            this.articleStockData.push(article)
          }
        })
      }
    )

    //create article purchase order in EM  if it's not Quote Type 
    if (this.appointmentDetails.appointmentType != "Quote") {
      let articleStockData = this.articleStockData;
      let LinesForPurchaseOrder = articleStockData.filter(x => x.localStock == 0)
      let articlePurchaseOrder = {
        BranchId: this.editAppointmentService.appointmentDetails.dealerId,
        AppointmentId: this.editAppointmentService.appointmentDetails.id,
        CustomerName: this.editAppointmentService.appointmentDetails.customerName,
        Note : this.editAppointmentService.appointmentDetails.workOrderNo+", "+ this.editAppointmentService.appointmentDetails.licensePlate,
        Lines: LinesForPurchaseOrder
          .map(article => ({
            ArticleName: article.name,
            SupplierArticleId: article.number,
            Price: article.listPrice,
            Discount: 0,
            Quantity: article.qty,
            Recyclefee: 0,
            Vat: article.vat
          }))
      }

      this.tecRMIService.createArticlePurchaseOrder(articlePurchaseOrder).then(result => {
        if (!isNullOrUndefined(result?.responseObject)) {
          //Add part details in Job
          this.mapAllArticleAndService(result.responseObject.retValue);
          this.spinner.hide();
          this.OnClose();
        }
        else {
          this.spinner.hide();
          this.OnDismiss();
        }
        this.spinner.hide();
      },
        _error => {
          this.OnDismiss();
          this.spinner.hide();
        });
    }
    else {
      this.mapAllArticleAndService("");
      this.spinner.hide();
      this.OnClose();
    }
  }

  mapAllArticleAndService(dmsPoId: any) {
    this.cartMainServices?.forEach(mainService => {
      mainService.selectedparts = []
      mainService.parts?.forEach(part => {
        if (part.isChecked) {
          //articlelist have number,genARTnumber, PartNumber(Part number assigned on front side by matching genARTNumber)
          //removing the logic of matching the part number , 
          //as article list with same genARTNumber, will have same PartNumber (although we have selected multiple different part number from service selection)

          // let partNo = part.partNo;
          // let articleOfService = this.articleStockData.filter(x => x.partCode == partNo)
          // articleOfService.forEach(article => {
          //   mainService.selectedparts.push(article)
          // });

          part.genArtNoList.forEach(y => {
            let articleOfService = this.articleStockData.filter(x => x.genArtNumber==y && (x.isChecked ? (x.isChecked==true ? true :false) : false)  );
            articleOfService.forEach(article => {
              if(mainService.selectedparts && mainService.selectedparts.length>0)   //if there is already selected parts check if is it alreday added in array
              {
                let partAlreadyExists=[];
                partAlreadyExists=mainService.selectedparts.filter(x=>x.number==article.number);
                if(partAlreadyExists.length == 0)
                {
                  mainService.selectedparts.push(article);
                }               
              }
              else
              {
                mainService.selectedparts.push(article);
              }
            });
          })


        }
      })
    })

    this.cartAdditionalServices?.forEach(additionalService => {
      additionalService.selectedparts = []
      additionalService.parts?.forEach(part => {
        if (part.isChecked) {

          //articlelist have number,genARTnumber, PartNumber(Part number assigned on front side by matching genARTNumber)
          //removing the logic of matching the part number , 
          //as article list with same genARTNumber, will have same PartNumber (although we have selected multiple different part number from service selection)

          // let partNo = part.partNo;
          // let articleOfService = this.articleStockData.filter(x => x.partCode == partNo)
          // articleOfService.forEach(article => {
          //   additionalService.selectedparts.push(article)
          // });

          part.genArtNoList.forEach(y => {
            let articleOfService = this.articleStockData.filter(x => x.genArtNumber==y && (x.isChecked ? (x.isChecked==true ? true :false) : false)  );
            articleOfService.forEach(article => {
              if(additionalService.selectedparts && additionalService.selectedparts.length>0)   //if there is already selected parts check if is it alreday added
              {
                let partAlreadyExists= [];
                partAlreadyExists=additionalService.selectedparts.filter(x=>x.number==article.number);
                if(partAlreadyExists.length == 0)
                {
                  additionalService.selectedparts.push(article);
                }
              }
              else
              {
                additionalService.selectedparts.push(article);
              }
              
            });
          })
        }
      })
    })

    let operations = []
    this.cartMainServices.forEach(mainService => {
      let selectedPartList = mainService.selectedparts
        .map(article => ({
          description: article.name,
          DMSPOLineGuid: dmsPoId,
          number: article.number,
          price: article.listPrice,
          quantity: article.qty,
          partSubGroupName: Constant.partSubGroupName, 
          pricing:
          {
            priceLevels:
              [{
                amount: article.listPrice
              }]
          }
        }));

      let labourDetails = [{
        description: mainService.workInfoText,
        times:
          [{
            //add local stock and kaha stock from here
            quantity: mainService.workTime
          }]
      }]

      let operation = {
        description: mainService.workInfoText,
        parts: selectedPartList,
        id: mainService.itemMpId,
        code: mainService.itemMpId,
        labourList: labourDetails,
        extSrcServiceType : Enums.ServiceType.TecRMIService,
        extSrcWorkId : mainService.workId
      }
      operations.push(operation)
    });

    this.cartAdditionalServices?.forEach(additionalService => {
      let selectedPartList = additionalService.selectedparts
        ?.map(article => ({
          description: article.name,
          DMSPOLineGuid: dmsPoId,
          number: article.number,
          price: article.listPrice,
          quantity: article.qty,
          partSubGroupName: Constant.partSubGroupName, 
          pricing:
          {
            priceLevels:
              [{
                amount: article.listPrice
              }]
          }
        }));

      let labourDetails = [
        {
          description: additionalService.workInfoText,
          times:
            [{
              //add local stock and kaha stock from here
              quantity: additionalService.workTime
            }]
        }
      ]

      let operation = {
        description: additionalService.workInfoText,
        parts: selectedPartList,
        id: additionalService.itemMpId,
        code: additionalService.itemMpId,
        labourList: labourDetails,
        extSrcServiceType : Enums.ServiceType.TecRMIAdditionalService,
        extSrcWorkId : additionalService.workId
      }
      operations.push(operation)
    });

    let ssmExportedResponseModel = {
      operations: operations
    }

    this.editAppointmentService.isExported = true;
    this.editAppointmentService.exportedJson = JSON.stringify(ssmExportedResponseModel);
  }

  isValidQty(event): void {
    const isDigit = Utility.isDigit(event) || Utility.isDecimalPoint(event);
    if (!isDigit) {
      event.preventDefault();
    }
  }

  checkQty(e, item){
    var partPrice = Number(e)
    item.qty = partPrice ;    
    if(item.qty < 1){
      this.isErrorOnStockBalanceStep = true
    }
    else{
      this.isErrorOnStockBalanceStep = false
      // this.availableStockBalance.forEach(x => {
      //   if(x.qty < 1){
      //     this.isErrorOnStockBalanceStep = true          
      //     return;
      //   }
      // })

      outerLoop:
      for(const item of this.displayStockDetails)
      {
        for(const x of item.stockDetails)
          {
            if(x.qty < 1){
              this.isErrorOnStockBalanceStep = true          
              break outerLoop;
            }
          }
      }

    }    
  } 

  OnDismiss() {
    this.activeModal.dismiss('Cross click')
  }

  OnClose() {
    this.activeModal.close("Save appointment data")
  }

}
